<template>
	<div class="flex justify-center">
		<!-- the dropdown is positioned against this wrapper, so it lines up with the button -->
		<div class="relative inline-block">
			<button type="button" class="btn-effect flex items-center  mb-2 bg-base-100 hover:bg-base-200 p-2 rounded-lg" @click="$refs.menu.open()">
				<div class="flex -space-x-7">
					<div v-for="color in allSelectedColors" class="w-8 h-8 mask mask-squircle" :class="'bg-' + color + '-300'"></div>
				</div>
				<ChevronDownIcon class="w-3 h-3 ml-1" />
			</button>

			<!-- Teleported into <body> and kept inside the window: in the settings drawer the
			     options would otherwise be cut off by the drawer's scroll area. -->
			<Dropdown ref="menu" position="bottom-start" teleport>
				<div class="bg-base px-4 py-4 shadow-lg rounded-lg flex flex-col items-center">
					<button type="button" @click="selectColors(availableColors)" class="btn-effect flex -space-x-7 mb-2">
						<div v-for="color in reversedArray(availableColors)" class="w-8 h-8 mask mask-squircle" :class="'bg-' + color + '-300'">
						</div>
					</button>
					<div class="flex flex-col gap-3">
						<hr>
						<button type="button"
							v-for="color in availableColors"
							@click="selectColors([color])"
							:key="color"
							class="btn-effect w-10 h-10 mask mask-squircle hover:bg-opacity-90"
							:class="'bg-' + color + '-300'"
						>
						</button>
					</div>
				</div>
			</Dropdown>
		</div>
	</div>
</template>

<script lang="ts">
import { Pupil } from "@/models/Pupil.model";
import { mapStores } from "pinia";
import { useActivityBoardStore } from '@/stores/ActivityBoard.store';
import { ChevronDownIcon } from "@heroicons/vue/24/outline";
import Dropdown from "@/components/ui/Dropdown.v2.vue";


export default {
	data() {
		return {
			availableColors: Pupil.COLORS,
		}
	},

	components: {
		ChevronDownIcon,
		Dropdown,
	},

	computed: {
		...mapStores(useActivityBoardStore),

		allSelectedColors() {
			return this.reversedArray(this.activityBoardStore.avatarSelectedColors);
		}
	},

	methods: {
		selectColors(colors: string[]) {
			this.activityBoardStore.setAvatarSelectedColors(colors)
			this.$refs.menu.close();

			if(this.$gtag) {
				this.$gtag.event('select-colors', {
					'event_category': 'activity-board',
					'event_label': 'configuration',
					'value': colors.join(','),
				});
			}
		},
		// returs a reversed COPY of the array (toReversed() is only supported as of Safari 15)
		reversedArray(array: any[]) {
			return array.slice().reverse();
		}
	}
}
</script>
